import {FETCH_TYPES, parseURL} from "../Connect";
import SystemConfig, {CONFIG_PARAMS, GAMECONF_PARAMS} from "../../system/SystemConfig";
import AddResult from "../result/AddResult";
import FetchAjax from "../FetchAjax";
import IConnectControl from "../controllers/IConnectControl";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import AbstractConnect from "./AbstractConnect";
import IDOM from "../../ui/IDOM";
import AbstractUIScreen, {ORIENTATION} from "../../ui/screen/AbstractUIScreen";
import PlatformSettings from "../result/PlatformSettings";

@injectable()
export default class ConnectAjaxPlatformSettings extends AbstractConnect {

    public readonly fetchType: string = FETCH_TYPES.PLATFORM_SETTINGS;
    timeout: number = 20000;
    private readonly initTimeout = this.timeout;

    private screen: AbstractUIScreen;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
        @inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
        @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM,
        @inject(SERVICE_IDENTIFIER.UIScreen) screen: AbstractUIScreen
    ) {
        super(config, control, fetch, dom);
        this.screen = screen;

        // use gameconf connect timeout if set,
        if (this.config.get(CONFIG_PARAMS.TIMEOUTS) && this.config.get(CONFIG_PARAMS.TIMEOUTS).platform_settings > 0) {
            this.timeout = this.config.get(CONFIG_PARAMS.TIMEOUTS).platform_settings * 1000;
            // @ts-ignore
            super.ajaxLoadingTimeout = this.timeout /9;
        }

        this.setMethod(this.config.get(CONFIG_PARAMS.URL_PLATFORM_SETTINGS_METHOD));
    }

    async fetch(data) {
        this.control.reset();
        this.data = data;

        this.timeout = this.initTimeout;

        try {
            let res = await this._fetch();
            return new PlatformSettings(res.data);

        } catch (e) {
            console.warn("Platform Settings: " + e.msg + ".  Continue with default Settings values.");
            return undefined;
        }
    }

    protected getParams(): Record<string, any> {
        let params = {
            "server_api": this.data.serverApi,
            "casino_id": this.data.casinoId,
            "session_id": this.data.sessionId
        };

        return params;
    }

    protected getUrl(): string {
        return parseURL(this.config.get(CONFIG_PARAMS.URL_PLATFORM_SETTINGS), {
            "casino_id": this.data.casinoId,
            "session_id": this.data.sessionId,
            "server_api": this.data.serverApi,
        });
    }
}